import type { Tool } from "./Tool";

/**
 * Passive tool: image placement is handled directly by the Canvas
 * component (floating preview + drag-to-place). This stub exists so
 * buildTool('image', ...) still returns a valid Tool while the image
 * tool is active.
 */
export class ImageStampTool implements Tool {
  readonly id = "image";

  onPointerDown(): void {}
  onPointerMove(): void {}
  onPointerUp(): void {}
}
